import { Trans } from '@lingui/react'
import { CartEntryItemERxV2PriceLabelEnum } from '@redteclab/api/clients/bully'
import type { FunctionComponent } from 'react'

import {
  PRESCRIPTION_TYPE_INSURANCE,
  PRESCRIPTION_TYPE_PRIVAT,
} from 'shared/consts/productTemplates'
import PriceLabelWithTooltip, {
  ModalType,
} from 'views/components/organisms/Cart/ProductListing/PriceLabelTooltip'
import type { ErxAndRxProductProps } from 'views/components/organisms/Cart/ProductListing/PriceLabelType'
import { isErxLifestyleProduct } from 'views/components/organisms/ProductTemplate/helpers'

import './ErxPriceLabel.scss'

const ErxPriceLabelMap = {
  [CartEntryItemERxV2PriceLabelEnum.Copayment]: (
    <Trans id="productPricing.buyBox.yourAdditionalPayment" />
  ),
  [CartEntryItemERxV2PriceLabelEnum.YourPrice]: (
    <Trans id="general.label.yourPrice" />
  ),
  [CartEntryItemERxV2PriceLabelEnum.CopaymentUpTo]: (
    <span>
      <Trans id="general.label.additionalChargeUpTo" /> <sup>17</sup>
    </span>
  ),
  [CartEntryItemERxV2PriceLabelEnum.SelfPayment]: (
    <Trans id="general.label.yourPrice" />
  ),
  [CartEntryItemERxV2PriceLabelEnum.SelfPaymentDueToExpiry]: (
    <Trans id="general.label.yourPrice" />
  ),
  [CartEntryItemERxV2PriceLabelEnum.AfterInvoice]: (
    <span>
      <Trans id="general.label.yourPrice" /> <sup>18</sup>
    </span>
  ),
  // NOTE: Deprecated
  [CartEntryItemERxV2PriceLabelEnum.NoCopayment]: <span></span>,
}

interface ErxPriceLabelProps {
  product: ErxAndRxProductProps
  evaluatedPrescriptionType: string
}

const ErxPriceLabel: FunctionComponent<ErxPriceLabelProps> = ({
  product,
  evaluatedPrescriptionType,
}: ErxPriceLabelProps) => {
  const isPublicInsurance =
    evaluatedPrescriptionType === PRESCRIPTION_TYPE_INSURANCE
  const isPrivateInsurance =
    evaluatedPrescriptionType === PRESCRIPTION_TYPE_PRIVAT

  if (
    product.priceLabel &&
    Object.values(CartEntryItemERxV2PriceLabelEnum).includes(
      product.priceLabel as CartEntryItemERxV2PriceLabelEnum
    )
  ) {
    const ErxPriceLabelComponent =
      ErxPriceLabelMap[product.priceLabel as CartEntryItemERxV2PriceLabelEnum]

    return (
      <span className="a-ErxPriceLabel">
        {ErxPriceLabelComponent}
        {(product.fixedPriceDifference as number) > 0 && (
          <PriceLabelWithTooltip
            modalType={ModalType.FIXED_PRICE}
            product={product}
            isERx
          />
        )}
        {isErxLifestyleProduct(product) && (
          <PriceLabelWithTooltip
            modalType={ModalType.LIFESTYLE}
            product={product}
            isERx
            hasBonus={isPrivateInsurance}
          />
        )}
        {isErxLifestyleProduct(product) && isPublicInsurance && (
          <PriceLabelWithTooltip
            product={product}
            isERx
            modalType={ModalType.BONUS_ONLY}
          />
        )}
      </span>
    )
  }

  return (
    <span className="a-ErxPriceLabel">
      <Trans id="general.label.sum" />
    </span>
  )
}

export default ErxPriceLabel
